module.exports = "https://static-frontbase.operabase.net/cb1b2179-7711-4a34-921d-c4deab5611f7/_next/static/images/opera-99dfccbed1f483ec2548ba22ef7b5b34.jpg";